import styled from 'styled-components'

import { ReactComponent as ArrowRightSvg } from '@sketch/icons/arrow-right-16'

export const ArrowDownIcon = styled(ArrowRightSvg)`
  color: ${({ theme }) => theme.colors.sketch.A};
  height: 16px;
  width: 16px;
  transform: rotate(90deg);
`

export const ArrowUpIcon = styled(ArrowRightSvg)`
  color: ${({ theme }) => theme.colors.sketch.A};
  height: 16px;
  width: 16px;
  transform: rotate(270deg);
`
